<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container v-if="!headers">
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>

    <v-layout v-if="headers && headers.length > 0">
      <v-row justify="center">
        <v-col style="max-width: 1200px">
          <material-card
            v-show="headers"
            :title="$t('components.searchmembersform.title')"
            :color="$vuetify.theme.themes.light.secondary"
            icon="person_search"
          >
            <v-card-text>
              <v-row>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.Last Name'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.lastName"
                    :label="$t('headers.members_management.Last Name')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.First Name'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.firstName"
                    :label="$t('headers.members_management.First Name')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) =>
                        h.text === 'headers.members_management.Membership Id'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.pensionMembershipId"
                    :label="$t('headers.members_management.Membership Id')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.Certificate'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.certificate"
                    :label="$t('headers.members_management.Certificate')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.SIN'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.sin"
                    :label="$t('headers.members_management.SIN')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) =>
                        h.text === 'headers.members_management.Date Of Birth'
                    )
                  "
                >
                  <pbas-date-picker
                    clearable
                    :label="$t('headers.members_management.Date Of Birth')"
                    :value="searchForm.dateOfBirth"
                    @update-date="searchForm.dateOfBirth = $event"
                    @keyup="keyUp"
                  ></pbas-date-picker>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.Address'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.city"
                    :label="$t('headers.members_management.City')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.Employer'
                    )
                  "
                >
                  <trans-select2
                    v-model="searchForm"
                    propertyName="employer"
                    transPropertyName="Current"
                    :items="employers"
                    :label="$t('headers.members_management.Employer')"
                    field="Name"
                    itemValue="Id"
                    @keyup="keyUp"
                    :loading="loadingEmployers"
                  ></trans-select2>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.Store'
                    )
                  "
                >
                  <trans-select2
                    v-model="searchForm"
                    propertyName="store"
                    transPropertyName="Current"
                    :items="stores"
                    :label="$t('headers.members_management.Store')"
                    field="Name"
                    itemValue="Id"
                    @keyup="keyUp"
                  ></trans-select2>
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) =>
                        h.text === 'headers.members_management.Phone Number'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.phoneNumber"
                    :label="$t('headers.members_management.Phone Number')"
                    @keyup="keyUp"
                  />
                </v-col>
                <v-col
                  cols="6"
                  v-if="
                    headers.some(
                      (h) => h.text === 'headers.members_management.Email'
                    )
                  "
                >
                  <no-autocomplete-textfield
                    clearable
                    v-model="searchForm.email"
                    :label="$t('headers.members_management.Email')"
                    @keyup="keyUp"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="auto">
                  <v-btn color="primary" @click="submitSearchForm">
                    {{ $t("pbascomponents.pbasdatatable.search") }}
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    text
                    @click="
                      searchForm.firstName = null;
                      searchForm.lastName = null;
                      searchForm.pensionMembershipId = null;
                      searchForm.certificate = null;
                      searchForm.sin = null;
                      searchForm.dateOfBirth = null;
                      searchForm.city = null;
                      searchForm.employer = null;
                      searchForm.store = null;
                      searchForm.phoneNumber = null;
                      submitSearchForm();
                    "
                  >
                    {{ $t("globals.reset") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </material-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-layout v-if="showTable">
      <v-row justify="center">
        <v-col style="max-width: 1200px">
          <v-card>
            <v-card-text>
              <div>
                <v-icon>list</v-icon>
                {{ $t("components.membersmanagementtable.results") }}
              </div>
              <pbas-data-table
                ref="table"
                :dataProvider="provider"
                :rowActions="rowActions"
                fileNamePrefix="members"
                identifier="search-member-table"
                :noSearch="true"
                :noActions="true"
                :exportDataSwitch="true"
                @error="error = $event"
                :exporters="$exporters"
                :showSelect="false"
              ></pbas-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>

    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { sortAlphanum } from "../alphanumericSort";
import TransSelect2 from "../components/TransSelect2";
import getHeaders from "../headers/SearchMembers";

export default {
  name: "search-members-form",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransSelect2,
  },
  props: [],
  mixins: [planSetter],
  data() {
    return {
      showTable: false,
      panel: [0, 1],
      searchForm: {
        firstName: null,
        lastName: null,
        pensionMembershipId: null,
        certificate: null,
        sin: null,
        dateOfBirth: null,
        city: null,
        employer: null,
        store: null,
        phoneNumber: null,
      },
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "viewItem",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.$router.push({ name: "memberView", params: { id: item.Id } });
          },
          visible: (item) => {
            return item;
          },
        },
      ],
      headers: null,
      selectedItem: null,
      employers: [],
      stores: [],
      loadingEmployers: false,
      columns: [
        "First Name",
        "Last Name",
        "SIN",
        "Membership Id",
        "Certificate",
        "Date Of Birth",
        "City",
        "Employer",
        "Store",
        "Phone Number",
        "Email",
      ],
    };
  },
  computed: {
    ...mapGetters("common", ["language", "settings"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    ...mapGetters("plansMembers", { planIdentity: "planIdentity" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    "searchForm.employer": {
      async handler(v) {
        if (v) {
          if (this.planParameters.HasStores) {
            if (v.Stores) {
              const collator = new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: "base",
              });
              this.stores = v.Stores.filter(
                (o) =>
                  o.Current !== null &&
                  o.Current !== undefined &&
                  o.Current.IsAssignable !== false
              ).sort(collator.compare);
            }
            if (
              !v.Stores ||
              v.Stores.filter((o) =>
                this.searchForm.Store
                  ? o.Id === this.searchForm.Store.Id
                  : false
              ).length === 0
            ) {
              this.searchForm.Store = null;
            }
          }
        } else {
          this.stores = [];
        }
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getEmployersDropDown",
      "validateUiTableHeaders",
    ]),
    ...mapActions("common", ["createOdataType"]),

    keyUp(evt) {
      if (evt.keyCode === 13) {
        // enter
        this.submitSearchForm();
        return;
      }
      return;
    },

    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },

    async loadPlanData(filter = null) {
      try {
        let headers = (
          await this.validateUiTableHeaders({
            planIdentityId: this.selectedPlan.Id,
            payload: this.columns,
          })
        ).data;
        // .data.sort((a, b) => {
        //   return a.order - b.order;
        // });
        // console.log(headers);
        this.headers = getHeaders(headers.filter((o) => o.ExistForPlan).map(o=>o.Name));

        let url = "plans/" + this.selectedPlan.Id + "/find-members";
        if (!filter) {
          this.provider = new PbasOData(this.$axiosHttp, url, this.headers);
        } else {
          const pr = new PbasOData(this.$axiosHttp, url, this.headers);
          pr.filter = filter;
          this.provider = pr;
        }

        this.$nextTick(() => {
          if (
            this.headers.some(
              (h) => h.text === "headers.members_management.Employer"
            )
          ) {
            this.loadEmployers();
          }
        });
      } catch (error) {
        this.error = error;
      }
    },
    async loadEmployers() {
      try {
        this.loadingEmployers = true;
        this.employers = (
          await this.getEmployersDropDown({
            plan: this.selectedPlan.Id,
            // url:
            //   "employers?$expand=Current($expand=Translations;$select=IdentityId,Name),Stores($expand=Current($expand=Translations;$select=IdentityId,Name,IsAssignable);$select=Id)&$select=Id",
          })
        ).data.sort((a, b) => {
          const translatedA = a.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          const translatedB = b.Current.Translations.filter(
            (o) => o.LanguageCode === this.language.language
          )[0].Name;
          return sortAlphanum(translatedA, translatedB);
        });
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingEmployers = false;
      }
    },
    async submitSearchForm() {
      const filters = [];
      this.provider.filter = undefined;
      if (this.searchForm.firstName) {
        filters.push(
          `contains(tolower(CurrentMember/FirstName), '${this.searchForm.firstName
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
      }
      if (this.searchForm.lastName) {
        filters.push(
          `contains(tolower(CurrentMember/LastName), '${this.searchForm.lastName
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
      }
      if (this.searchForm.email) {
        filters.push(
          `contains(tolower(Email), '${this.searchForm.email
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
      }
      if (this.searchForm.pensionMembershipId) {
        filters.push(
          `contains(tolower(MemberIdentification/PensionMembershipId), '${this.searchForm.pensionMembershipId
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
        // filters.push(
        //   `startswith(MemberIdentification/Certificate, '${this.searchForm.certificate.replaceAll(
        //     "'",
        //     "''"
        //   )}')`
        // );
      }
      if (this.searchForm.certificate) {
        filters.push(
          `contains(tolower(MemberIdentification/Certificate), '${this.searchForm.certificate
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
      }
      if (this.searchForm.sin) {
        filters.push(
          `(contains(tolower(MemberIdentification/SIN), '${this.searchForm.sin
            .toLowerCase()
            .replaceAll("'", "''")}') or
          contains(tolower(MemberIdentification/TemporarySIN), '${this.searchForm.sin
            .toLowerCase()
            .replaceAll("'", "''")}'))`
        );
        // filters.push(
        //   `startswith(MemberIdentification/SIN, '${this.searchForm.sin.replaceAll(
        //     "'",
        //     "''"
        //   )}')`
        // );
      }
      if (this.searchForm.city) {
        filters.push(
          `contains(tolower(CurrentContactInformation/Address/City), '${this.searchForm.city.toLowerCase()}')`
        );
      }
      if (this.searchForm.phoneNumber) {
        filters.push(
          `contains(tolower(CurrentContactInformation/PhoneNumber), '${this.searchForm.phoneNumber.toLowerCase()}')`
        );
      }
      if (this.searchForm.dateOfBirth) {
        const dob = this.searchForm.dateOfBirth; //.split("T")[0];
        filters.push(
          //`((indexof(cast(CurrentMember/DateOfBirth, 'Edm.String'), '${dob}')) ge 0 and (indexof(cast(CurrentMember/DateOfBirth, 'Edm.String'), '${dob}')) le 10)`
          `date(CurrentMember/DateOfBirth) eq ${dob}`
        );
      }
      if (this.searchForm.employer) {
        filters.push(
          `(CurrentEmploymentInformation/Employer/Id eq ${this.searchForm.employer.Id})`
        );
      }
      if (this.searchForm.store) {
        filters.push(
          `(CurrentEmploymentInformation/Store/Id eq ${this.searchForm.store.Id})`
        );
      }

      if (filters.length > 0) {
        const f = filters.join(" and ");
        console.log(filters, f);
        this.provider.filter = f;
        this.showTable = true;
        this.$nextTick(() => {
          this.$refs.table.getDataAsync();
        });
      } else {
        this.showTable = false;
      }

      //await this.loadPlanData(filters.join(" and "));
    },
  },
};
</script>
